import React from 'react';
export const BonusesSection: React.FC = () => {
  return <section className="bg-white py-20 px-5 text-center" data-id="element-16">
      <div className="inline-block bg-gradient-to-br from-green-brand to-green-light text-white py-[7px] px-[22px] rounded-full text-xs font-sans font-bold tracking-[2px] uppercase mb-[15px]" data-id="element-17">
        🎁 4 BONOS ESTRATÉGICOS
      </div>
      <h2 className="text-[clamp(24px,4vw,42px)] text-[#1A1A1A] mb-2.5 leading-[1.2]" data-id="element-18">
        Y Además Recibís{' '}
        <em className="text-brown-light not-italic" data-id="element-19">4 Bonos</em> que
        <br data-id="element-20" />
        Eliminan Cada Obstáculo de tu Obra
      </h2>
      <p className="text-base text-[#777] font-sans mb-[45px] max-w-[600px] mx-auto" data-id="element-21">
        Siempre incluidos. Sin costo adicional. Diseñados para que no tengas
        excusas para no empezar.
      </p>

      <div className="grid grid-cols-[repeat(auto-fit,minmax(240px,1fr))] gap-5 max-w-[1000px] mx-auto mb-[30px]" data-id="element-22">
        {/* Bono 1 */}
        <div className="bg-[#FAFAF5] border border-[#E8E8E0] rounded-2xl py-7 px-[22px] text-left relative transition-all duration-300 hover:border-brown-light hover:shadow-[0_8px_30px_rgba(179,92,55,0.1)] hover:-translate-y-1" data-id="element-23">
          <div className="absolute -top-3 left-[22px] bg-gradient-to-br from-brown-light to-brown-mid text-white w-7 h-7 rounded-full flex items-center justify-center font-black text-[13px] font-sans" data-id="element-24">
            1
          </div>
          <span className="text-4xl mb-3 block mt-2" data-id="element-25">📅</span>
          <h3 className="text-base text-[#1A1A1A] font-sans font-bold mb-2 leading-[1.3]" data-id="element-26">
            Plan 30 Días: De los Vicios a la Disciplina de Obra
          </h3>
          <p className="text-[13px] text-[#666] font-sans leading-[1.6] mb-[15px]" data-id="element-27">
            Tu sargento de obra personal. Qué hacer cada día exacto para que el
            proyecto no muera por procrastinación. Semana a semana, sin
            improvisar.
          </p>
          <div className="flex justify-between items-center" data-id="element-28">
            <span className="text-sm text-brown-light font-sans font-bold line-through opacity-60" data-id="element-29">
              $7.500
            </span>
            <span className="bg-green-brand text-white py-1 px-3.5 rounded-full text-xs font-sans font-bold" data-id="element-30">
              GRATIS
            </span>
          </div>
        </div>

        {/* Bono 2 */}
        <div className="bg-[#FAFAF5] border border-[#E8E8E0] rounded-2xl py-7 px-[22px] text-left relative transition-all duration-300 hover:border-brown-light hover:shadow-[0_8px_30px_rgba(179,92,55,0.1)] hover:-translate-y-1" data-id="element-31">
          <div className="absolute -top-3 left-[22px] bg-gradient-to-br from-brown-light to-brown-mid text-white w-7 h-7 rounded-full flex items-center justify-center font-black text-[13px] font-sans" data-id="element-32">
            2
          </div>
          <span className="text-4xl mb-3 block mt-2" data-id="element-33">📊</span>
          <h3 className="text-base text-[#1A1A1A] font-sans font-bold mb-2 leading-[1.3]" data-id="element-34">
            Eco-Estimator Pro: Calculadora de Materiales
          </h3>
          <p className="text-[13px] text-[#666] font-sans leading-[1.6] mb-[15px]" data-id="element-35">
            Excel automatizado. Ingresás los m2 de tu casa y te dice exactamente
            cuánta tierra, arena, paja y cal comprar. Ahorrá hasta 30% en
            logística.
          </p>
          <div className="flex justify-between items-center" data-id="element-36">
            <span className="text-sm text-brown-light font-sans font-bold line-through opacity-60" data-id="element-37">
              $5.000
            </span>
            <span className="bg-green-brand text-white py-1 px-3.5 rounded-full text-xs font-sans font-bold" data-id="element-38">
              GRATIS
            </span>
          </div>
        </div>

        {/* Bono 3 */}
        <div className="bg-[#FAFAF5] border border-[#E8E8E0] rounded-2xl py-7 px-[22px] text-left relative transition-all duration-300 hover:border-brown-light hover:shadow-[0_8px_30px_rgba(179,92,55,0.1)] hover:-translate-y-1" data-id="element-39">
          <div className="absolute -top-3 left-[22px] bg-gradient-to-br from-brown-light to-brown-mid text-white w-7 h-7 rounded-full flex items-center justify-center font-black text-[13px] font-sans" data-id="element-40">
            3
          </div>
          <span className="text-4xl mb-3 block mt-2" data-id="element-41">⚖️</span>
          <h3 className="text-base text-[#1A1A1A] font-sans font-bold mb-2 leading-[1.3]" data-id="element-42">
            Guía de Permisos y Legalidad Municipal
          </h3>
          <p className="text-[13px] text-[#666] font-sans leading-[1.6] mb-[15px]" data-id="element-43">
            Cómo hablar con el municipio en el "idioma técnico" correcto para
            que aprueben tu proyecto de tierra. Incluye el "hack legal" de la
            Quincha.
          </p>
          <div className="flex justify-between items-center" data-id="element-44">
            <span className="text-sm text-brown-light font-sans font-bold line-through opacity-60" data-id="element-45">
              $4.500
            </span>
            <span className="bg-green-brand text-white py-1 px-3.5 rounded-full text-xs font-sans font-bold" data-id="element-46">
              GRATIS
            </span>
          </div>
        </div>

        {/* Bono 4 */}
        <div className="bg-[#FAFAF5] border border-[#E8E8E0] rounded-2xl py-7 px-[22px] text-left relative transition-all duration-300 hover:border-brown-light hover:shadow-[0_8px_30px_rgba(179,92,55,0.1)] hover:-translate-y-1" data-id="element-47">
          <div className="absolute -top-3 left-[22px] bg-gradient-to-br from-brown-light to-brown-mid text-white w-7 h-7 rounded-full flex items-center justify-center font-black text-[13px] font-sans" data-id="element-48">
            4
          </div>
          <span className="text-4xl mb-3 block mt-2" data-id="element-49">🌿</span>
          <h3 className="text-base text-[#1A1A1A] font-sans font-bold mb-2 leading-[1.3]" data-id="element-50">
            El Manual del Techo Vivo
          </h3>
          <p className="text-[13px] text-[#666] font-sans leading-[1.6] mb-[15px]" data-id="element-51">
            Cómo construir una cubierta vegetal paso a paso. Tu aire
            acondicionado natural que regula la temperatura y cosecha agua de
            lluvia gratis.
          </p>
          <div className="flex justify-between items-center" data-id="element-52">
            <span className="text-sm text-brown-light font-sans font-bold line-through opacity-60" data-id="element-53">
              $3.000
            </span>
            <span className="bg-green-brand text-white py-1 px-3.5 rounded-full text-xs font-sans font-bold" data-id="element-54">
              GRATIS
            </span>
          </div>
        </div>
      </div>

      <div className="bg-gradient-to-br from-[#F5F0E8] to-[#FFF8F0] border-2 border-dashed border-brown-light rounded-xl py-5 px-[30px] max-w-[500px] mx-auto flex justify-between items-center flex-wrap gap-2.5 md:flex-col md:text-center" data-id="element-55">
        <span className="text-base font-sans font-bold text-[#333]" data-id="element-56">
          Valor total de los 4 bonos
        </span>
        <span className="text-[22px] font-black text-brown-light font-sans line-through opacity-60" data-id="element-57">
          $20.000
        </span>
        <span className="text-[22px] font-black text-green-brand font-sans" data-id="element-58">
          → GRATIS con tu Mega Pack
        </span>
      </div>
    </section>;
};